import type { HTTPService } from "@soft-db/http";
import type { UpdateUser, User, UserAuth } from "./user-api";

export type CurrentUser = User & {
	auth: UserAuth;
};

export class CurrentUserApi {
	constructor(private _http: HTTPService) {}

	async fetch() {
		return await this._http.get<CurrentUser>("user");
	}

	async update(props: Partial<UpdateUser>) {
		return await this._http.patch<CurrentUser>("user", props);
	}

	async updateEmail(email: string) {
		return await this._http.put<CurrentUser>(`user/email`, { email });
	}

	async updateAvatar(file: File) {
		return await this._http.postFile<CurrentUser>("user/avatar", "file", file);
	}

	async deleteAvatar() {
		return await this._http.delete<CurrentUser>("user/avatar");
	}

	async updateStations(stations: string[]) {
		return await this._http.put<void>("users/me/favorites/stations", { stations });
	}

	async addStation(station: string) {
		return await this._http.put<void>(`users/me/favorites/stations/${station}`);
	}

	async removeStation(station: string) {
		return await this._http.delete<void>(`users/me/favorites/stations/${station}`);
	}

	async addMultipleStations(stations: string[]) {
		return await this._http.post<void>(`users/me/favorites/stations`, {
			operation: "add",
			stations,
		});
	}

	async removeMultipleStations(stations: string[]) {
		return await this._http.post<void>(`users/me/favorites/stations`, {
			operation: "remove",
			stations,
		});
	}

	async updateSites(sites: string[]) {
		return await this._http.put<void>("users/me/favorites/sites", { sites });
	}

	async addSite(site: string) {
		return await this._http.put<void>(`users/favorites/sites/${site}`);
	}

	async removeSite(sites: string) {
		return await this._http.delete<void>(`users/favorites/sites/${sites}`);
	}

	async addMultipleSites(sites: string[]) {
		return await this._http.post<void>(`users/me/favorites/sites`, {
			operation: "add",
			sites,
		});
	}

	async removeMultipleSites(sites: string[]) {
		return await this._http.post<void>(`users/me/favorites/sites`, {
			operation: "remove",
			sites,
		});
	}
}
